import { TApplicationState } from '../../types/redux';

export const isFloorPlanAvailableSelector = (state: TApplicationState) => {
  return state.newbuilding.isFloorPlanAvailable;
};
